import { CheckCircle2, Clock, XCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { TaxonomyIntent } from '@/hooks/useTaxonomyRun'

interface ApprovalBarProps {
  intents: TaxonomyIntent[]
  onApproveAll: () => void
  onResetAll:   () => void
}

export function ApprovalBar({ intents, onApproveAll, onResetAll }: ApprovalBarProps) {
  // Derive counts from current intent state
  const approved = intents.filter(i => i.approved === 'approved').length
  const rejected = intents.filter(i => i.approved === 'rejected').length
  const pending  = intents.filter(i => i.approved === 'pending').length

  return (
    <div className="flex items-center justify-between py-2 mb-3">
      {/* Summary badges */}
      <div className="flex items-center gap-3">
        <span className="flex items-center gap-1 text-sm text-green-700 bg-green-50 px-2.5 py-0.5 rounded-full">
          <CheckCircle2 className="w-3.5 h-3.5" />
          {approved} approved
        </span>
        <span className="flex items-center gap-1 text-sm text-amber-700 bg-amber-50 px-2.5 py-0.5 rounded-full">
          <Clock className="w-3.5 h-3.5" />
          {pending} pending
        </span>
        <span className="flex items-center gap-1 text-sm text-red-700 bg-red-50 px-2.5 py-0.5 rounded-full">
          <XCircle className="w-3.5 h-3.5" />
          {rejected} rejected
        </span>
      </div>

      {/* Bulk actions */}
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" onClick={onApproveAll} disabled={pending === 0}>
          Approve All
        </Button>
        <Button variant="ghost" size="sm" onClick={onResetAll} disabled={pending === intents.length}>
          Reset
        </Button>
      </div>
    </div>
  )
}
